import { useContext } from 'react'

import {
    IChannelsSettingsRouteContext,
    IQueryParamsEdit,
    IQueryParamsList,
    ChannelsSettingsRouteContext
} from 'plugin-channelmanager/ChannelsSettings/ChannelsSettingsWrapper'

export function useRouteContext(): IChannelsSettingsRouteContext<IQueryParamsList | IQueryParamsEdit> {
    return useContext<IChannelsSettingsRouteContext<IQueryParamsEdit | IQueryParamsList>>(ChannelsSettingsRouteContext)
}
